module.exports = __webpack_public_path__ + "static/media/student14.68e3c1e7.png";